import { createStyles, makeStyles } from '@material-ui/core';

export const useBaseStyles = makeStyles(() =>
  createStyles({
    paper: {
      boxShadow: 'none',
      padding: '40px',
      border: '1px solid #E5E5E5',
      maxWidth: 580,
    },
  })
);
